// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JSdn","input":"styles_input__1liFW"};